import { render } from "./OtpRefreshButton.vue?vue&type=template&id=2e765120&scoped=true"
import script from "./OtpRefreshButton.vue?vue&type=script&lang=js"
export * from "./OtpRefreshButton.vue?vue&type=script&lang=js"

import "./OtpRefreshButton.vue?vue&type=style&index=0&id=2e765120&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e765120"]])

export default __exports__